namespace Gamification.Gamification {
    export interface NodiRow {
        IdNodo?: number;
        UserId?: number;
        TenantId?: number;
        Nome?: string;
        Descrizione?: string;
        IdRisorsa?: number;
        Progressivo?: number;
        AnimationPath?: string;
        PunteggioNodo?: number;
        IsPunteggioNodoNegativo?: number;
        Crediti?: number;
        Exp?: number;
        IdChecklist?: number;
        IdProdottoEsperienza?: number;
        PunteggioMissione?: number;
        IsPunteggioMissioneNegativo?: number;
        IdChecklistNome?: string;
        IdRisorsaNome?: string;
        IdProdottoEsperienzaNome?: string;
    }

    export namespace NodiRow {
        export const idProperty = 'IdNodo';
        export const nameProperty = 'Nome';
        export const localTextPrefix = 'Gamification.Nodi';
        export const lookupKey = 'Gamification.Nodi';

        export function getLookup(): Q.Lookup<NodiRow> {
            return Q.getLookup<NodiRow>('Gamification.Nodi');
        }
        export const deletePermission = 'Gamification:Configurazione:View';
        export const insertPermission = 'Gamification:Configurazione:View';
        export const readPermission = 'Gamification:Configurazione:View';
        export const updatePermission = 'Gamification:Configurazione:View';

        export declare const enum Fields {
            IdNodo = "IdNodo",
            UserId = "UserId",
            TenantId = "TenantId",
            Nome = "Nome",
            Descrizione = "Descrizione",
            IdRisorsa = "IdRisorsa",
            Progressivo = "Progressivo",
            AnimationPath = "AnimationPath",
            PunteggioNodo = "PunteggioNodo",
            IsPunteggioNodoNegativo = "IsPunteggioNodoNegativo",
            Crediti = "Crediti",
            Exp = "Exp",
            IdChecklist = "IdChecklist",
            IdProdottoEsperienza = "IdProdottoEsperienza",
            PunteggioMissione = "PunteggioMissione",
            IsPunteggioMissioneNegativo = "IsPunteggioMissioneNegativo",
            IdChecklistNome = "IdChecklistNome",
            IdRisorsaNome = "IdRisorsaNome",
            IdProdottoEsperienzaNome = "IdProdottoEsperienzaNome"
        }
    }
}
